import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Box, Button, FlexGrid, StackView } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

import TankNumber from './components/tankNumber';
import TankName from './components/tankName';
import TankProduct from './components/tankProduct';
import TankType from './components/tankType';
import TankHeightSelect from './components/tankHeightSelect';
import TankLength from './components/tankLength';
import TankCapacity from './components/tankCapacity';
import TankPortSize from './components/tankPortSize';

const AddDetailsFormFuelPressure = ({
  tankDetailsFarmAndRanch,
  setTankDetailsFarmAndRanch,
  sectionError
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const initialState = {
    valueTankNumber: '',
    valueTankName: '',
    valueTankProduct: '',
    valueTankType: '',
    valueTankHeight: '',
    valueTankHeightOther: '',
    valueTankLength: '',
    valueTankCapacity: '',
    valueTankPortSize: ''
  };

  const [dataField, setDataField] = useState(initialState);
  const [error, setError] = useState('');

  const validateForm = () =>
    [
      'valueTankNumber',
      'valueTankName',
      'valueTankProduct',
      'valueTankType',
      'valueTankHeight',
      'valueTankLength',
      'valueTankCapacity',
      'valueTankPortSize'
    ].every(field => dataField[field] !== '');

  const onAddInfo = () => {
    if (!validateForm()) {
      setError('Please enter all necessary information');
      return;
    }
    setTankDetailsFarmAndRanch({
      ...tankDetailsFarmAndRanch,
      fuelPressure: [...tankDetailsFarmAndRanch.fuelPressure, dataField]
    });
    setDataField(initialState);
    setError('');
  };

  useEffect(() => {
    setError(sectionError);
  }, [sectionError]);

  return (
    <StackView space={3}>
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col>
            <StackView space={3}>
              <TankNumber
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankName
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankProduct
                typeKey="fuelPressure"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Gasoline', 'Diesel']}
                error={error}
              />
              <TankType
                typeKey="fuelPressure"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Horizontal', 'Vertical']}
                error={error}
              />
              <TankHeightSelect
                typeKey="fuelPressure"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={[
                  '05 sensor <5m (16 ft)',
                  '10 sensor <10m (32 ft)',
                  '15 sensor <15m (49 ft)',
                  'Other'
                ]}
                error={error}
              />
              <TankLength
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankCapacity
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankPortSize
                typeKey="fuelPressure"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['2in NPT', 'Other']}
                error={error}
              />
            </StackView>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
      <Box style={{ padding: '1.5rem' }}>
        <Button onPress={onAddInfo}>{addButton}</Button>
      </Box>
    </StackView>
  );
};

AddDetailsFormFuelPressure.propTypes = {
  tankDetailsFarmAndRanch: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTankDetailsFarmAndRanch: PropTypes.func.isRequired,
  sectionError: PropTypes.string.isRequired
};

export default AddDetailsFormFuelPressure;
